import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent implements OnInit {
  constructor(
    private readonly msalService: MsalService,
    private readonly location: Location
  ) {}

  ngOnInit(): void {
    const sidebarElement = document.getElementById('sidebar-menu');
    if (sidebarElement) {
      sidebarElement.classList.add('d-none');
    }

    const headerElement = document.getElementById('header');
    if (headerElement) {
      headerElement.classList.add('d-none');
    }

    const sidebarContent = document.getElementById('sidebarMenuContent');
    if (sidebarContent) {
      sidebarContent.classList.add('m-0');
    }
  }

  login(): void {
    sessionStorage.clear();
    localStorage.clear();
    this.msalService.logout();
  }
  check(): void {
    this.location.back();
  }
}
